export default {
  serializedIcon() {
    let icon = this.get("icon");
    if (_.isObject(icon)) {
      // Object or Array
      return JSON.stringify(icon);
    } else {
      return icon;
    }
  },
};



// WEBPACK FOOTER //
// ./src/models/mixins/has_icon.js